import { render, staticRenderFns } from "./GemiHacziForm.vue?vue&type=template&id=10570c23"
import script from "./GemiHacziForm.vue?vue&type=script&lang=ts"
export * from "./GemiHacziForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports